"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _useMinicart2 = require("@deosite/api/hooks/common/useMinicart");
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _router = require("next/router");
var __jsx = _react["default"].createElement;
var CloseIcon = function CloseIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.347 20.838l-15-15 .848-.848 15 15-.848.848z",
    fill: "#2E4557"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.347 19.838l15-15 .848.849-15 15-.848-.849z",
    fill: "#2E4557"
  }));
};
CloseIcon.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Minicart = function Minicart(props) {
  var router = (0, _router.useRouter)();
  var children = props.children,
    button = props.button,
    checkoutButton = props.checkoutButton,
    itemsAmountInCart = props.itemsAmountInCart;
  var _useMinicart = (0, _useMinicart2.useMinicart)(),
    toggleMinicartVisibility = _useMinicart.toggleMinicartVisibility,
    isMinicartLoading = _useMinicart.isMinicartLoading;
  var translations = {
    buttonLabel: (0, _langLibrary["default"])("Go to checkout")
  };
  var orderButton = /*#__PURE__*/_react["default"].cloneElement(checkoutButton, {
    sx: {
      width: "100%",
      $rounded: true
    },
    isLoading: isMinicartLoading,
    onClick: function onClick() {
      if (isMinicartLoading) return;
      toggleMinicartVisibility();
      router.push("/checkout");
    }
  }, translations.buttonLabel);
  return __jsx(_Box["default"], {
    sx: {
      width: ["100%", null, "auto"],
      background: "white",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      position: ["fixed", null, "relative"],
      overflowY: "hidden",
      pt: 50
    }
  }, __jsx(_Box["default"], {
    sx: {
      p: "s3",
      height: 50,
      position: "fixed",
      zIndex: 2,
      bg: "white",
      top: 0,
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].cloneElement(button, {
    onClick: function onClick() {
      return toggleMinicartVisibility({
        close: true
      });
    }
  }, __jsx(CloseIcon, null))), __jsx(_Box["default"], {
    sx: {
      px: "s8",
      pt: [20, null, 0],
      pb: [100, null, 0],
      overflowY: "auto"
    }
  }, children), itemsAmountInCart > 0 && __jsx(_Box["default"], {
    sx: {
      width: "100%",
      height: 83,
      pl: "s8",
      pr: ["s8", null, null, null, "s6"],
      py: 25,
      position: ["fixed", null, "sticky"],
      bottom: 0,
      bg: "white"
    }
  }, __jsx(_Box["default"], {
    sx: {
      position: "relative",
      bottom: 15
    }
  }, orderButton)));
};
var _default = Minicart;
exports["default"] = _default;